import { api, type Api } from "@api/bot-base-api-request";
import { useMutation } from "@tanstack/react-query";

const BOT_SWITCH_CHAIN_QUERY_KEY = "bot-switch-chain";

type BotSwitchChainParams = {
  appPubKey: string;
  userId: string;
  chainId: number;
  idToken: string;
};

// Define the return type for the API response
interface BotSwitchChainResponse {
  currentChainId: number;
  success: boolean;
  // Add any other properties that the API returns
}

const postBotSwitchChain = async (
  api: Api,
  params: BotSwitchChainParams,
): Promise<BotSwitchChainResponse> =>
  api
    .post("switchChain", {
      json: params,
      headers: { Authorization: `Bearer ${params.idToken}` },
    })
    .json();

const useBotSwitchChainMutation = () =>
  useMutation<BotSwitchChainResponse, Error, BotSwitchChainParams>({
    mutationFn: async (params: BotSwitchChainParams) =>
      postBotSwitchChain(api, params),
    mutationKey: [BOT_SWITCH_CHAIN_QUERY_KEY],
  });

export {
  useBotSwitchChainMutation,
  postBotSwitchChain,
  BOT_SWITCH_CHAIN_QUERY_KEY,
};

export type { BotSwitchChainParams, BotSwitchChainResponse };
